import { Component, h, Host, Prop } from '@stencil/core';


@Component({
    tag: 'lilu-rounded-icon-button',
    styleUrl: 'lilu-rounded-icon-button.scss',
    shadow: true
})
export class LiluRoundedIconButton {

    @Prop() size = 'size-sm';
    @Prop() color: string;
    @Prop() icon: string;
    @Prop() iconSize: string;
    @Prop() iconColor: string;
    @Prop() disabled: boolean = false;
    @Prop() appearance: string = ''


    render() {
        return (
            <Host>
                <button
                    class={`${this.size} ${this.color} ${this.appearance}`}
                    disabled={this.disabled}
                >
                    <lilu-icon size={this.iconSize} color={this.iconColor} type={this.icon}></lilu-icon>
                </button>
            </Host>
        );
    }
}
